/*
 * App.js — Root React component for the Xclusive Driving School site.
 * Sets up client-side routing (react-router) for the 5 pages, a global toast
 * container (sonner), the fixed navbar, footer, and the sticky mobile
 * WhatsApp/Book bar. ScrollToTop resets scroll position on every route change.
 */

import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/site/Navbar";
import { Footer } from "./components/site/Footer";
import { MobileBar } from "./components/site/MobileBar";
import Home from "./pages/Home";
import DrivingLessons from "./pages/DrivingLessons";
import Reviews from "./pages/Reviews";
import Areas from "./pages/Areas";
import Contact from "./pages/Contact";
import PdiTraining from "./pages/PdiTraining";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Navbar />
        <main className="pb-20 lg:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/driving-lessons" element={<DrivingLessons />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/areas-we-cover" element={<Areas />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/adi-part-3-pdi-training" element={<PdiTraining />} />
          </Routes>
        </main>
        <Footer />
        <MobileBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
